<div class="table-header py-3 px-3">
  <div class="header-content">
    <h2 class="table-title">{{ 'app.settings.user_management.table.title' | translate }}</h2>
    <button mat-icon-button (click)="facade.reload()"
      class="d-flex align-items-center justify-content-center focus-outline-none"
      [matTooltip]="'shared.general.tooltips.refresh' | translate" [disabled]="facade.isLoading()">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>
  @if (facade.count()) {
  <div class="count-line">
    <span class="count-badge">{{ facade.count() }}</span>
    <span class="count-label">{{ 'app.settings.user_management.table.users_found_suffix' | translate }}</span>
  </div>
  }
</div>
<div class="table-wrapper">
  <table mat-table [dataSource]="dataSource()" matSort (matSortChange)="onSortChange($event)">
    <ng-container matColumnDef="index">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.user_management.table.columns.index' | translate }}
      </th>
      <td mat-cell *matCellDef="let row; let i = index">{{ i + 1 }}</td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="name">
        {{ 'app.settings.user_management.table.columns.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ row.name || row.displayName }}</td>
    </ng-container>

    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header="email">
        {{ 'app.settings.user_management.table.columns.email' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <app-table-copy-cell [content]="row.email || row.userPrincipalName"
          [tooltipText]="'app.settings.user_management.table.columns.email' | translate">
        </app-table-copy-cell>
      </td>
    </ng-container>

    <ng-container matColumnDef="mobilePhone">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.user_management.table.columns.mobile_phone' | translate
        }}</th>
      <td mat-cell *matCellDef="let row">{{ row.mobilePhone }}</td>
    </ng-container>

    <ng-container matColumnDef="role">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.user_management.table.columns.role' | translate }}</th>
      <td mat-cell *matCellDef="let row">{{ row.role?.name ?? 'shared.general.labels.na' | translate }}</td>
    </ng-container>

    <ng-container matColumnDef="licence">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.user_management.table.columns.licence' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">
        <span class="av-billing-badge" [class]="'av-billing-badge--' + licenceStateClass(row)"
          [matTooltip]="row.licence?.cancels_at ? ('app.billing.licences.states.ending_on' | translate: { date: row.licence.cancels_at | date: 'mediumDate' }) : ''">
          {{ licenceStateKey(row) | translate }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="joinDate">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.user_management.table.columns.join_date' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">{{ (row.created_at | date: 'dd/MM/yyyy') ?? 'shared.general.labels.na' | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>{{ 'app.settings.user_management.table.columns.action' | translate }}
      </th>
      <td mat-cell *matCellDef="let row">


        @if (row.id && row.role?.name !== 'root') {
        @if (rbacOff()) {
        <a class="delete-action" (click)="confirmRemoveSeat(row)" [style.color]="'var(--avyna-color-error)'">
          {{ 'shared.general.buttons.remove_seat' | translate }}
        </a>
        } @else if (currentUser()?.hasPermission(permissions.USER_EDIT)) {
        <a [routerLink]="['/settings/users', row.id]" [style.color]="'var(--avyna-color-primary)'">
          {{ 'shared.general.buttons.edit' | translate }}
        </a>
        } @else {
        <a class="delete-action" (click)="confirmRemoveSeat(row)" [style.color]="'var(--avyna-color-error)'">
          {{ 'shared.general.buttons.remove_seat' | translate }}
        </a>
        }
        } @else {
        <mat-icon>cancel</mat-icon>
        }
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  @if (dataSource().data.length === 0) {
  <div class="no-data-content mt-5 pt-5">
    @if (facade.isLoading()) {
    <mat-spinner diameter="40"></mat-spinner>
    <span>{{ 'app.users.table.loading' | translate }}</span>
    } @else {
    <span>{{ 'app.users.table.no_data' | translate }}</span>
    }
  </div>
  }

  <app-table-loading-bar [isLoading]="facade.isLoading()"></app-table-loading-bar>
</div>

@if (facade.count() > 0) {
<mat-paginator class="pagination-bar" [length]="facade.count()" [pageIndex]="facade.pageIndex()"
  [pageSize]="facade.pageSize()" [pageSizeOptions]="[facade.pageSize()]" [hidePageSize]="true"
  [showFirstLastButtons]="true" (page)="onPageChange($event)">
</mat-paginator>
}